import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';

import useStyles from './styles';


const PreviewComponent = ({ src, removeImage, title, disabled }) => {
  const classes = useStyles();
  return (
    <div className={classNames(
      classes.preview,
      { [classes.disabled]: disabled },
    )}>
      <div
        className={classes.deleteBtn}
        onClick={removeImage}
        onKeyPress={removeImage}
        role="button"
        tabIndex={0}
      >
        <FontAwesomeIcon icon={faTimesCircle} size="2x" />
      </div>
      <div
        style={{
          backgroundImage: `url(${src})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center center',
          height: '100%',
          width: '100%',
        }}
        alt="current logo"
      />
      <div className={classes.previewTitle}>{title}</div>
    </div>
  );
};


PreviewComponent.defaultProps = {
  title: '',
};

PreviewComponent.propTypes = {
  src: PropTypes.string.isRequired,
  removeImage: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default PreviewComponent;
